/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GetRegion } from 'constants.js';
import {
  hidePinForm,
  showPinForm,
} from 'containers/PinForm/actions/pinForm.actions';
import { Form } from 'cvlib';
import {
  activateChannelPin,
  checkControlPin,
  clearActivateChannelPin,
  clearCheckControlPin,
} from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { selectIsLive } from 'containers/Player/selectors/media.selector';
import { getRegion } from 'utils/Region';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';

const style = {
  width: '136px',
  height: '40px',
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.35rem',
};

const CheckPinForm = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isLive = useSelector(selectIsLive);
  const recordingSelected = useSelector(
    store => store.Player.RecordingSelected,
  );
  const contentData = useSelector(store => store.Player?.Content?.data);
  const translations = useSelector(state => state.translations);
  const user = useSelector(state => state.user);
  const checkControlPinStatus = useSelector(
    state => state.cvEpg.channelBlocker.checkControlPin,
  );
  const activateChannelPinStatus = useSelector(
    state => state.cvEpg.channelBlocker.activateChannelPin,
  );
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;

  const pinMessages = {
    noRightLength: translate('modal_activate_pin_message'),
    invalid: translate('lockChannel_tooltip_valid_label_validation'),
  };

  const [value, setValue] = useState('');
  const [currentError, setCurrentError] = useState(null);

  const {
    title,
    onSuccess,
    onNextClicked = pin => dispatch(checkControlPin(pin)),
    onCancelClicked = () => {
      dispatch(hidePinForm());
      dispatch(clearCheckControlPin());
      if (isLive === false && !recordingSelected) {
        navigate(
          `/${getRegion()}/vcard/${contentData?.group?.common?.title_uri}/${
            contentData?.group?.common?.id
          }`,
        );
      }
    },
    onPinRecoveryClicked = () => {
      dispatch(clearCheckControlPin());
      if (user.validEmail) {
        dispatch(
          showPinForm({
            type: 'PIN_RECOVERY',
          }),
        );
      } else {
        dispatch(hidePinForm());
        navigate(
          `/${GetRegion()}/completeinfo?${createSearchParams({
            from: location.pathname,
            recoveryPin: true,
          })}`,
        );
      }
    },
  } = props;

  useEffect(
    () => {
      if (checkControlPinStatus.inProgress === false) {
        if (checkControlPinStatus.success === true) {
          if (props.type === 'SET_PIN_CHANNEL') {
            dispatch(activateChannelPin(value));
          }
          if (props.type === 'UNBLOCK_CHANNEL') {
            onSuccess(value);
          }
          dispatch(clearCheckControlPin());
        } else if (checkControlPinStatus.error) {
          setCurrentError(pinMessages.invalid);
        }
      }
    },
    [checkControlPinStatus.inProgress],
  );
  useEffect(
    () => {
      if (activateChannelPinStatus.inProgress === false) {
        if (activateChannelPinStatus.success === true) {
          if (props.type === 'SET_PIN_CHANNEL') {
            onSuccess();
            dispatch(clearActivateChannelPin());
          }
        } else if (activateChannelPinStatus.error) {
          setCurrentError(pinMessages.invalid);
        }
      }
    },
    [activateChannelPinStatus],
  );

  const handleSubmit = () => {
    if (value.trim().length < 4) {
      setCurrentError(pinMessages.noRightLength);
    } else {
      onNextClicked(value);
    }
  };

  const elements = [
    {
      element: 'subtitle',
      content: title,
      style: {
        paddingTop: '1.75rem',
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
    {
      element: 'item',
      expand: 3,
      position: 'center',
      type: 'pin',
      message: translate('email_tooltip_valid_label_validation'),
      error: currentError,
      name: 'pinInput',
      id: 'pinInput',
      autoFocus: true,
      handleSubmit,
      onChange: newValue => {
        setValue(newValue);
        setCurrentError(null);
      },
    },
    {
      element: 'group',
      direction: 'horizontal',
      expand: 1,
      style: { width: '264px' },
      children: [
        {
          element: 'button',
          type: 'gray',
          content: translate('register_access_option_button_cancel'),
          onClick: onCancelClicked,
          expand: 1,
          style,
          className: 'grayButton',
        },
        {
          element: 'button',
          type: 'red',
          content: translate('register_access_option_button_next'),
          onClick: handleSubmit,
          dimmed: value.trim().length < 4,
          disabled: value.trim().length < 4,
          expand: 1,
          style: { ...style, marginLeft: '16px' },
          className: 'redButton',
        },
      ],
    },
    {
      element: 'button',
      type: 'gray',
      content: translate('lockChannel_access_option_button_recoveryPIN'),
      onClick: onPinRecoveryClicked,
      style: { width: '288px' },
      className: 'grayButton',

      expand: 5,
    },
  ];

  return <Form elements={elements} classes={['pin-form-container']} />;
};

CheckPinForm.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  onCancelClicked: PropTypes.func.isRequired,
  onPinRecoveryClicked: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

CheckPinForm.defaultProps = {
  title: 'Ingresa tu PIN de seguridad para bloquar este canal',
};

export default CheckPinForm;
